module.exports = __webpack_public_path__ + "img/serve.4f587700.png";